export default __webpack_public_path__ + "static/media/pok-search-not-found.d737cabb.jpg";